import { IListingStatsResponse } from "../../../../models/Part";
import classNames from "../../../../utils/classNames";
import DashboardTile from "../../../dashboard/DashboardTile";
import { MISSING_FIELD_OPTIONS } from "../missingFields";

interface IListedMissingTableProps {
  listingStats: IListingStatsResponse;
  selectedMissingFields?: string[];
  onToggleMissingField?: (key: string) => void;
}

export default function ListedMissingTable({ listingStats, selectedMissingFields, onToggleMissingField }: IListedMissingTableProps) {

  const selected = selectedMissingFields ?? [];
  const isInteractive = !!onToggleMissingField;

  const renderMissingTable = () => (
    <table className="min-w-full border-collapse">
      <thead>
        <tr className="border-b border-gray-300 text-left text-sm font-semibold text-gray-700">
          <th className="py-2 px-3 w-1/2">Field</th>
          <th className="py-2 px-3 text-right">Missing Count</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200">
        {MISSING_FIELD_OPTIONS.map((field) => {
          const count = listingStats.listingsMissing[field.key] || 0;
          const isActive = selected.includes(field.key);
          return (
            <tr
              key={field.key}
              onClick={isInteractive ? () => onToggleMissingField!(field.key) : undefined}
              className={classNames(
                isInteractive && "cursor-pointer hover:bg-gray-50",
                isActive && "bg-primary-50"
              )}
            >
              <td className="py-2 px-3 font-medium text-gray-900">
                <span className="flex items-center gap-2">
                  {isInteractive && (
                    <span
                      className={classNames(
                        "inline-block h-3 w-3 rounded-sm border",
                        isActive ? "bg-primary-600 border-primary-600" : "border-gray-300"
                      )}
                    />
                  )}
                  {field.label}
                </span>
              </td>
              <td className="py-2 px-3 text-right font-semibold text-primary-600">
                {count}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );

  return (
    <DashboardTile span={1}>
      <div className="">
        <div className="mb-4 flex items-center justify-between">
          <div className="prose">
            <h3 className="m-0">Missing Fields</h3>
          </div>
        </div>

        <div className="overflow-x-auto overflow-y-scroll max-h-[25vh]">
          {renderMissingTable()}
        </div>
      </div>
    </DashboardTile>
  );
}
